import { Box } from "@mui/material";
import { ElementType } from "react";

type AccordionHeaderIconProps = {
  icon: ElementType;
  onClick: () => void;
};

export function AccordionHeaderIcon({
  icon: Icon,
  onClick,
}: AccordionHeaderIconProps) {
  return (
    <Box>
      <Icon tooltipText={"Editar Endereço do Cliente"} onClick={onClick} />
    </Box>
  );
}
